/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { useState } from 'react'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import withStyles from '@material-ui/core/styles/withStyles'
import copy from 'copy-to-clipboard'
import classNames from 'classnames'
import { connect } from 'react-redux'
// import omitBy from 'lodash/omitBy'

// material UI
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
// import Paper from '@material-ui/core/Paper'
// import Box from '@material-ui/core/Box'
// import Button from '@material-ui/core/Button'
// import TextField from '@material-ui/core/TextField'

// material ui icon
import FileCopyIcon from '@material-ui/icons/FileCopy'
import { FcCheckmark as FcCheckmarkIcon } from 'react-icons/fc'

import { actions as snackbarActions } from 'store/modules/snackbar'

// my components
// import UserComponentName from 'components/molecules/UserComponentName'

// my containers
// import UserContainerName from 'containers/UserContainerName'

// libraries
// import config from 'config'
import { isFunction, isEmptyString, isString } from 'lib/detectType'
import bindStateToProps from 'lib/bindStateToProps'
import bindActionCreators from 'lib/bindActionCreators'

const styles = theme => ({
  root: {},
  copyWrap: {
    verticalAlign: 'middle',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    wordBreak: 'break-all',
    whiteSpace: 'pre-wrap'
  },
  childrenWrap: {
    display: 'inline'
  },
  clickableChildrenWrap: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  icon: {
    color: '#0000005e',
    fontSize: '0.8em'
  },
  iconButton: {
    marginLeft: 4
  }
})
const CopyButton = props => {
  const { classes, title, copyText, onCopy } = props
  const [visibleSuccessIcon, setCurrentStatus] = useState(false)
  return (
    <Tooltip
      title={
        visibleSuccessIcon === true
          ? '복사 완료!'
          : isEmptyString(title)
          ? '복사하기'
          : `${title} 복사하기`
      }
      open={visibleSuccessIcon || undefined}
    >
      <IconButton
        size="small"
        className={classes.iconButton}
        onClick={e => {
          e.stopPropagation()
          setCurrentStatus(true)
          setTimeout(() => {
            setCurrentStatus(false)
          }, 1000)
          copy(copyText)
          if (isFunction(onCopy)) {
            onCopy(copyText)
          }
        }}
      >
        {visibleSuccessIcon === true ? (
          <FcCheckmarkIcon className={classes.icon} />
        ) : (
          <FileCopyIcon className={classes.icon} />
        )}
      </IconButton>
    </Tooltip>
  )
}
const CopyContent = props => {
  const {
    classes,
    clickable,
    SnackbarActions,
    copyText,
    title = '',
    children,
    onCopy
  } = props
  return (
    <span
      className={classNames(classes.childrenWrap, {
        [classes.clickableChildrenWrap]: clickable === true
      })}
      onClick={() => {
        if (clickable === true) {
          SnackbarActions.new({
            severity: 'success',
            message: `${title} 복사했습니다.`
          })
          copy(copyText)
          if (isFunction(onCopy)) {
            onCopy(copyText)
          }
        }
      }}
    >
      {children}
    </span>
  )
}
export const useProps = {}
/**
 * 글자 복사
 */
const SimpleCopy = ({ classes, proxy, ...props }) => {
  const {
    SnackbarActions,
    children = null,
    title = '',
    copyText,
    onCopy,
    noWrap = false,
    clickable = false
  } = props
  if (!isString(copyText) || isEmptyString(copyText)) return children
  return (
    <span className={classNames(classes.copyWrap, {})}>
      {noWrap === true ? (
        <Grid container noWrap>
          <Grid item>
            <CopyContent
              {...{
                classes,
                clickable,
                SnackbarActions,
                copyText,
                title,
                onCopy
              }}
            >
              {children}
            </CopyContent>
          </Grid>
          {clickable === false && (
            <Grid item>
              <CopyButton
                SnackbarActions={SnackbarActions}
                classes={classes}
                title={title}
                copyText={copyText}
                onCopy={onCopy}
              />
            </Grid>
          )}
        </Grid>
      ) : (
        <>
          {clickable === true ? (
            <Tooltip title={`${title} 복사하기`}>
              <span>
                <CopyContent
                  {...{
                    classes,
                    clickable,
                    SnackbarActions,
                    copyText,
                    title,
                    onCopy
                  }}
                >
                  {children}
                </CopyContent>
              </span>
            </Tooltip>
          ) : (
            <CopyContent
              {...{
                classes,
                clickable,
                SnackbarActions,
                copyText,
                title,
                onCopy
              }}
            >
              {children}
            </CopyContent>
          )}
          {clickable === false && (
            <CopyButton
              SnackbarActions={SnackbarActions}
              classes={classes}
              title={title}
              copyText={copyText}
              onCopy={onCopy}
            />
          )}
        </>
      )}
    </span>
  )
}

SimpleCopy.defaultProps = setDefaultProps(useProps)
SimpleCopy.propTypes = setPropTypes(useProps)
export default connect(
  bindStateToProps({}),
  bindActionCreators({
    snackbarActions
  })
)(withStyles(styles)(SimpleCopy))
